<template>
  <b-container fluid>
    <div class="diler-info">
      <b-table-simple small stacked>
        <b-tbody>
          <b-tr>
            <b-td stacked-heading="Наименование">{{ dealerInfo.p_opf }} {{ dealerInfo.p_fullname }}</b-td>
            <b-td stacked-heading="ИНН/КПП">{{ dealerInfo.p_inn }}<span v-if="dealerInfo.p_kpp"> / {{dealerInfo.p_kpp}}</span></b-td>
            <template v-for="(contact, index) in dealerInfo.p_contacts">
              <b-td :key="index" stacked-heading="Контактное лицо">{{ contact.name || '' }}, {{ contact.phone || '' }}, {{ contact.email || '' }}</b-td>
            </template>
          </b-tr>
        </b-tbody>
      </b-table-simple>
    </div>
    <b-card no-body>
      <b-tabs @input="getTableData" card content-class="mt-3">
        <b-tab title="Прайсы" active>
          <div>
            <b-dropdown
              variant="success"
              class="mb-4"
              text="Добавить прайс">
              <b-dropdown-item @click="openDaobitPrice">Даобит</b-dropdown-item>
              <b-dropdown-item @click="openPskovPrice()">Псков</b-dropdown-item>
              <b-dropdown-item @click="openKgdPrice">Калининград</b-dropdown-item>
              <b-dropdown-item @click="openPikYugPrice">Пик-ЮГ</b-dropdown-item>
            </b-dropdown>
            <b-table
              id="data_table"
              hover
              show-empty
              responsive
              ref="prices"
              :fields="fields"
              :items="items"
              class="mt-3 text-center"
              tbody-tr-class="td-centered"
              empty-text="Нет данных в таблице">
              <template v-slot:cell(key)="data">
                <p class="mb-0">{{ data.index + 1 }}</p>
              </template>
              <template v-slot:cell(date)="data">
                <p class="mb-0">{{ data.item.start_month }}.{{ data.item.start_year }}</p>
              </template>
              <template v-slot:cell(status)="data">
                <p v-if="data.item.price_status === 'active'" class="mb-0"><b-badge variant="success">Активный</b-badge></p>
                <p v-if="data.item.price_status === 'future'" class="mb-0"><b-badge variant="primary">Будущий</b-badge></p>
                <p v-if="data.item.price_status === 'archive'" class="mb-0"><b-badge variant="secondary">Архивный</b-badge></p>
              </template>
              <template v-slot:cell(actions)="data">
                <div class="actions-wrapper">
                  <div class="btn-wrapper">
                    <b-button
                      @click="editPrice(data)"
                      variant="outline-secondary"
                      class="actions-with-outline"
                      v-b-tooltip.hover title="Редактировать">
                      <i class="fas fa-pencil-alt" />
                    </b-button>
                  </div>
                </div>
              </template>
            </b-table>
          </div>
        </b-tab>
        <b-tab title="Спецусловия">
          <div>
            <b-dropdown
              variant="success"
              class="mb-4"
              text="Добавить">
              <b-dropdown-item @click="openSpecialConditionPrice">Cпецусловие</b-dropdown-item>
              <b-dropdown-item @click="openSpecApi()">Cпецусловие API</b-dropdown-item>
              <b-dropdown-item v-if="dealerInfo.p_id === 3" @click="openSpecMinimal()">Тариф Минимальный</b-dropdown-item>
            </b-dropdown>
            <b-table
              id="data_table"
              hover
              show-empty
              responsive
              ref="specialConditions"
              :fields="fieldsSpecialPrices"
              :items="dealerSpecialPricesFiltered"
              class="mt-3 text-center"
              tbody-tr-class="td-centered"
              empty-text="Нет данных в таблице">
              <template v-slot:cell(key)="data">
                <p class="mb-0">{{ data.index + 1 }}</p>
              </template>
              <template v-slot:cell(date)="data">
                <p v-if="data.item.type === 'spec_condition' || data.item.type === 'api'" class="mb-0">{{ data.item.start_month }}.{{ data.item.start_year }}</p>
                <p v-else class="mb-0">{{ moment(data.item.start_date).format('DD.MM.YYYY') }}</p>
              </template>
              <template v-slot:cell(type)="data">
                <p v-if="data.item.type === ''" class="mb-0">{{ data.item.start_month }}.{{ data.item.start_year }}</p>
              </template>
              <template v-slot:cell(package_count)="data">
                <p v-if="data.item.type === 'Тариф &quot;Минимальный&quot;'" class="mb-0">{{ (data.item.initial_package_count - data.item.actual_package_count) }}/{{ data.item.actual_package_count }}</p>
              </template>
              <template v-slot:cell(status)="data">
                <p v-if="data.item.price_status === 'active'" class="mb-0"><b-badge variant="success">Активный</b-badge></p>
                <p v-if="data.item.price_status === 'future'" class="mb-0"><b-badge variant="primary">Будущий</b-badge></p>
                <p v-if="data.item.price_status === 'archive'" class="mb-0"><b-badge variant="secondary">Архивный</b-badge></p>
              </template>
              <template v-slot:cell(type)="data">
                <p v-if="data.item.type === 'spec_condition'" class="mb-0">Спецусловие</p>
                <p v-else-if="data.item.type === 'api'" class="mb-0">Спецусловие API</p>
                <p v-else class="mb-0">{{ data.item.type }}</p>
              </template>
              <template v-slot:cell(actions)="data">
                <div class="actions-wrapper">
                  <div class="btn-wrapper">
                    <b-button
                      @click="editSpecialCondition(data)"
                      variant="outline-secondary"
                      class="actions-with-outline"
                      v-b-tooltip.hover title="Редактировать">
                      <i class="fas fa-pencil-alt" />
                    </b-button>
                  </div>
                </div>
              </template>
            </b-table>
          </div>
        </b-tab>
      </b-tabs>
    </b-card>
    <add-daobit-price
      :startMonth="startMonth"
      :startYear="startYear"
      :disabled="priceDisabled"
      :addPrice="addDaobitPrice">
    </add-daobit-price>
    <add-kgd-price
      :startMonth="startMonth"
      :startYear="startYear"
      :disabled="priceDisabled"
      :addPrice="addKgdPrice">
    </add-kgd-price>
    <add-pik-yug-price
      :startMonth="startMonth"
      :startYear="startYear"
      :disabled="priceDisabled"
      :addPrice="addPikYugPrice">
    </add-pik-yug-price>
    <add-pskov-price
      :startMonth="startMonth"
      :startYear="startYear"
      :disabled="priceDisabled"
      :addPrice="addPskovPrice">
    </add-pskov-price>
    <add-spec-api-price
      :disabled="priceDisabled"
      :clientId="clientId"
      :startMonth="startMonth"
      :startYear="startYear"
      :addPrice="addSpecApiPrice">
    </add-spec-api-price>
    <add-special-condition-price
      :clientId="clientId"
      :disabled="priceDisabled"
      :addPrice="addSpecialConditionPrice"
      :startMonth="startMonth"
      :startYear="startYear">
    </add-special-condition-price>
    <add-special-minimal-price
      :clientOrgId="clientId"
      :dealerOrgId="dealerInfo.p_org_id"
      :disabled="priceDisabled"
      :addPrice="addSpecMinimalPrice"
      :startMonth="startMonth"
      :startYear="startYear">
    </add-special-minimal-price>
  </b-container>
</template>

<script>
import AddDaobitPrice from './AddDaobitPrice'
import AddPskovPrice from './AddPskovPrice'
import AddKgdPrice from './AddKgdPrice'
import AddPikYugPrice from './AddPikYugPrice'
import AddSpecApiPrice from './AddSpecialConditionApiPrice'
import AddSpecialConditionPrice from './AddSpecialConditionPrice'
import AddSpecialMinimalPrice from './AddSpecialMinimalPrice'
import { mapActions, mapState, mapMutations } from 'vuex'
import moment from 'moment'

export default {
  name: 'DealerPricesForm',
  components: {
    AddDaobitPrice,
    AddPskovPrice,
    AddKgdPrice,
    AddPikYugPrice,
    AddSpecApiPrice,
    AddSpecialMinimalPrice,
    AddSpecialConditionPrice
  },
  data () {
    return {
      addSpecApiPrice: true,
      addSpecMinimalPrice: true,
      addPskovPrice: true,
      addDaobitPrice: true,
      addKgdPrice: true,
      addPikYugPrice: true,
      addSpecialConditionPrice: true,
      fields: [
        { key: 'key', label: '№' },
        { key: 'name', label: 'Наименование', thStyle: { width: '50%' } },
        { key: 'status', label: 'Статус' },
        { key: 'date', label: 'Дата применения' },
        { key: 'actions', label: 'Действия' }
      ],
      fieldsSpecialPrices: [
        { key: 'key', label: '№' },
        { key: 'client_name', label: 'Наименование', thStyle: { width: '50%' } },
        { key: 'package_count', label: 'Пакетов' },
        { key: 'status', label: 'Статус' },
        { key: 'type', label: 'Тип' },
        { key: 'date', label: 'Дата применения' },
        { key: 'actions', label: 'Действия' }
      ],
      startMonth: null,
      startYear: null,
      priceDisabled: true,
      clientId: null
    }
  },
  watch: {},
  mounted () {},
  beforeDestroy () {
    this.setDealerData(null)
    this.setDealerSpecialPrices(null)
    this.setDealerMinimalPrices(null)
  },
  computed: {
    ...mapState(
      {
        dealerData: state => state.dealers.dealerData,
        dealerSpecialPrices: state => state.dealers.dealerSpecialPrices,
        dealerMinimalPrices: state => state.dealers.dealerMinimalPrices,
        userInfo: state => state.authorization.userInfo
      }
    ),
    items () {
      return this.dealerData ? this.dealerData.prices : []
    },
    dealerInfo () {
      return this.dealerData ? this.dealerData.dealer : {}
    },
    dealerSpecialPricesFiltered () {
      if (this.dealerInfo.p_id === 3) {
        if (this.dealerSpecialPrices && this.dealerMinimalPrices && this.dealerMinimalPrices.results) return this.dealerSpecialPrices.concat(this.dealerMinimalPrices.results)
        else return this.dealerSpecialPrices
      } else return this.dealerSpecialPrices
    }
  },
  methods: {
    moment: function (date) {
      moment.locale('ru')
      return moment(date)
    },
    isBillingAdmin () {
      const hasRights = this.userInfo.rights.filter(item => {
        return item === 'billing_admin'
      })
      return (hasRights.length > 0)
    },
    getTableData (event) {
      if (event === 0) {
        this.getDealerPricesData({ id: this.$route.params.id })
      }
      if (event === 1) {
        this.getDealerSpecialPrices({ id: this.$route.params.id })
        if (this.dealerInfo.p_id === 3) this.getDealerMinimalPrices({ org_id: this.dealerInfo.p_org_id })
      }
    },
    openSpecApi () {
      this.addSpecApiPrice = true
      this.priceDisabled = false
      this.startMonth = null
      this.startYear = null
      this.$root.$emit('bv::toggle::collapse', 'spec-api-price-sidebar')
    },
    openSpecMinimal () {
      this.addSpecMinimalPrice = true
      this.priceDisabled = false
      this.startMonth = null
      this.startYear = null
      this.$root.$emit('bv::toggle::collapse', 'spec-minimal-price-sidebar')
    },
    openSpecialConditionPrice () {
      this.addSpecialConditionPrice = true
      this.priceDisabled = false
      this.startMonth = null
      this.startYear = null
      this.$root.$emit('bv::toggle::collapse', 'special-condition-price-sidebar')
    },
    openPikYugPrice () {
      this.addPikYugPrice = true
      this.priceDisabled = false
      this.startMonth = null
      this.startYear = null
      this.$root.$emit('bv::toggle::collapse', 'pik-yug-price-sidebar')
    },
    openKgdPrice () {
      this.addKgdPrice = true
      this.priceDisabled = false
      this.startMonth = null
      this.startYear = null
      this.$root.$emit('bv::toggle::collapse', 'kgd-price-sidebar')
    },
    openDaobitPrice () {
      this.addDaobitPrice = true
      this.priceDisabled = false
      this.startMonth = null
      this.startYear = null
      this.$root.$emit('bv::toggle::collapse', 'daobit-price-sidebar')
    },
    openPskovPrice () {
      this.addPskovPrice = true
      this.priceDisabled = false
      this.startMonth = null
      this.startYear = null
      this.$root.$emit('bv::toggle::collapse', 'pskov-price-sidebar')
    },
    editPrice (data) {
      this.startMonth = data.item.start_month
      this.startYear = data.item.start_year
      this.priceDisabled = (data.item.price_status !== 'future')
      switch (data.item.billing_type_alias) {
        case 'dyn_tp':
          this.addDaobitPrice = false
          this.$root.$emit('bv::toggle::collapse', 'daobit-price-sidebar')
          break
        case 'dyn_disc_multi':
          this.addPskovPrice = false
          this.$root.$emit('bv::toggle::collapse', 'pskov-price-sidebar')
          break
        case 'dyn_mc_disc':
          this.addKgdPrice = false
          this.$root.$emit('bv::toggle::collapse', 'kgd-price-sidebar')
          break
        case 'dyn_pu':
          this.addPikYugPrice = false
          this.$root.$emit('bv::toggle::collapse', 'pik-yug-price-sidebar')
          break
      }
    },
    editSpecialCondition (data) {
      this.startMonth = data.item.start_month
      this.startYear = data.item.start_year
      this.clientId = data.item.client_id
      this.priceDisabled = (data.item.price_status !== 'future')
      if (this.isBillingAdmin()) {
        this.priceDisabled = false
      }
      this.addSpecialConditionPrice = false
      this.addSpecApiPrice = false
      this.addSpecMinimalPrice = false
      if (data.item.type === 'spec_condition') {
        this.$root.$emit('bv::toggle::collapse', 'special-condition-price-sidebar')
      }
      if (data.item.type === 'api') {
        this.$root.$emit('bv::toggle::collapse', 'spec-api-price-sidebar')
      }
      if (data.item.type === 'Тариф "Минимальный"') {
        this.clientId = data.item.client_org_id
        this.$root.$emit('bv::toggle::collapse', 'spec-minimal-price-sidebar')
      }
    },
    ...mapActions({
      getDealerPricesData: 'dealers/getDealerPricesData',
      getDealerSpecialPrices: 'dealers/getDealerSpecialPrices',
      getDealerMinimalPrices: 'dealers/getDealerMinimalPrices'
    }),
    ...mapMutations({
      setDealerData: 'dealers/setDealerData',
      setDealerSpecialPrices: 'dealers/setDealerSpecialPrices',
      setDealerMinimalPrices: 'dealers/setDealerMinimalPrices'
    })
  }
}
</script>

<style lang="scss" scoped>
  .diler-info {
    margin-top: 10px;
    margin-bottom: 10px;
    font-size: 17px;
  }

  .table.b-table.b-table-stacked > tbody > tr > :first-child {
    border-top-width: 1px;
  }

  tr {
    font-size: 15px;
  }

  .table.b-table.b-table-stacked > tbody > tr > [data-label]::before {
    text-align: left;
    font-weight: 500;
  }

  .actions-wrapper {
    display: flex;
    justify-content: center;
    align-items: stretch;
    .btn-wrapper {
      height: 32px;
      display: flex;
    }
    .actions-with-outline {
      border-radius: 50%;
      width: 32px;
      height: 32px;
      position: relative;
      border: 2px solid #CFD8DC;
      &:nth-child(1) {
        margin-right: 0.75rem;
      }
      &:nth-child(2) {
        margin-right: 0.75rem;
      }
      &:hover {
        color: #fff !important;
        cursor: pointer;
      }
      i {
        width: 16px;
        height: 16px;
        text-align: center;
        margin-right: 8px;
        position: absolute;
        top: calc((100% - 16px) / 2);
        left: calc((100% - 16px) / 2);
      }
    }
  }
</style>
